export default {
    Metadata: {
        Name: "isDirtyForm",
        Description: "Returns true if the form or any embedded form has unsaved data changes.",
        Syntax: "isDirtyForm()",
        Keywords: ['Logical'],
        Author: "DataVoke, Inc.",
        UpdatesOnData: true
    },
    execute(mvc) {
        try {
            if (typeof(mvc) == "undefined") {
                mvc = app.dv.helpers.exprEng.currexpression.mvc;
            }
            return app.dv.mvc.isDirty(mvc);

        } catch (e) {
            return false;
        }
        return false;
    },
};

